export default __webpack_public_path__ + "static/hero_news-2c04b323e9692cdf12f0bef4847a3d1a.jpg";